import BirthdayMessageConfig from './BirthdayMessageConfig';

export default BirthdayMessageConfig;
